/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  getUsage() {
    return axios.get(`/api/v1/accounts/${this.accountIdFromRoute}/usage`);
  }

  getStorageCleanup() {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/storage_cleanup`
    );
  }

  startStorageCleanup() {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/storage_cleanup`
    );
  }

  toggleDeletion(actionType) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/toggle_deletion`,
      { action_type: actionType }
    );
  }
}

export default new AccountAPI();
